import React, { useState, useEffect } from "react";
import {
  Drawer,
  Typography,
  IconButton,
  Button,
  Checkbox,
  FormControlLabel,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { Table } from "react-bootstrap";
import {
  Box,
  CircularProgress,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import {
  Close as CloseIcon,
  Visibility as VisibilityIcon,
} from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Dropdown, Label, Text, TextField } from "@fluentui/react";
// Added by Gauri to fix dropdown position issue on 20 Nov 2025
import { DirectionalHint } from "@fluentui/react";
import { toast } from "react-toastify";
import axios from "axios";
import AxiosInstance1 from "app/hooks/AxiosInstance/AxiosInstance1";

// Commented and Code Added By Madhuri.K on 22-04-2025
const WorkflowChangeNOI = ({
  data1,
  data2,
  data3,
  initiativesID,
  onRefresh,
}) => {
  // console.log("WorkflowChangeNOI - data1:", data1);
  // console.log("WorkflowChangeNOI - data2:", data2);
  // console.log("WorkflowChangeNOI - data3:", data3);
  const [currentStageData, setCurrentStageData] = useState(null);
  const [selectedNOI, setSelectedNOI] = useState(""); // Store selected NOI
  const [selectedNOIName, setSelectedNOIName] = useState("");
  const accessToken = sessionStorage.getItem("access_token");
  const userdata = JSON.parse(sessionStorage.getItem("user"));
  const employeeId = userdata?.employeeId;
  const [workflowData, setWorkflowData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [NOIDrawerOpen, setNOIDrawerOpen] = useState(false);
  const [selectedNOI1, setSelectedNOI1] = useState("");
  const [showPreview, setShowPreview] = useState(false);
  // Added by Gauri to save Changed Nature of Initiative on 31 Mar 2025
  const [previousNOI, setPreviousNOI] = useState("");
  const [rationale, setRationale] = useState(null);
  const [includeCurrentStage, setIncludeCurrentStage] = useState(false);
  const [currentNOIText, setCurrentNOIText] = useState(null);
  // Added By Madhuri.K on 24-04-2025
  const [currentNOIID, setCurrentNOIID] = useState(null);
  //   const [isCurrentNOIID, setIsCurrentNOIID] = useState(null);

  const getSemiCircleStyle = (isFirst, isLast) => {
    return {
      content: '""',
      position: "absolute",
      top: 0,
      bottom: 0,
      left: isFirst ? "-10px" : undefined,
      right: isLast ? "-10px" : undefined,
      width: "15px",
      backgroundColor: "inherit",
      borderLeft: !isLast ? "1px solid #e0e0e0" : undefined,
      borderRight: isLast ? "1px solid #e0e0e0" : undefined,
      borderRadius: "50%",
      zIndex: 0,
    };
  };

  useEffect(() => {
    if (data2?.natureofDemand || data2?.natureofDemandID) {
      setCurrentNOIText(data2.natureofDemand);
      setCurrentNOIID(data2?.natureofDemandID);
    }
  }, [data2]);

  {
    /* Added by Gauri on 02 May 2025 */
  }
  //   useEffect(() => {
  //     if (NOIDrawerOpen) {
  //       setSelectedNOI1(selectedNOI); // Bind main dropdown value when opening drawer
  //       console.log("NOIDrawerOpen selectedNOI1", selectedNOI1);
  //       setRationale("");
  //       setIncludeCurrentStage("");
  //       // setIncludeCurrentStage(false);

  //     }
  //   }, [NOIDrawerOpen, selectedNOI]); // Runs when `NOIDrawerOpen` or `selectedNOI` changes

  useEffect(() => {
    if (NOIDrawerOpen) {
      setRationale("");
      setIncludeCurrentStage("");
    }
  }, [NOIDrawerOpen]);

  {
    /* Added by Gauri on 02 May 2025 */
  }
  //   useEffect(() => {
  //     if (NOIDrawerOpen && selectedNOI) {
  //       setSelectedNOI1(selectedNOI); // Sync only when drawer is open
  //     }
  //   }, [selectedNOI, NOIDrawerOpen]);

  {
    /* Added by Gauri on 02 May 2025 */
  }
  //   useEffect(() => {
  //     if (selectedNOI1 === "" && currentNOIID) {
  //       // Force update even if value hasn't changed
  //       // setSelectedNOI1(currentNOIID + ""); // Convert to new string ref
  //       setSelectedNOI1(currentNOIID);
  //       handleClick();
  //     }
  //   }, [selectedNOI1, currentNOIID]);

  const handleClick = async (overrideNOI) => {
    {
      /* Added by Gauri on 02 May 2025 */
    }
    const noiToUse = overrideNOI || selectedNOI1 || currentNOIID;

    if (!noiToUse) {
      console.warn("NOI is undefined, skipping API call.");
      return; // Prevent invalid API call
    }

    setLoading(true);
    try {
      const response = await AxiosInstance1.get(
        // Commented and modified NOI parameter value to show details as per selected value from the dropdown stages on 24 Mar 2025
        `/api/ManageWorkFlow/GetManageWorkFlowChangeNOI?IdeaID=${initiativesID}&NOI=${noiToUse}`
        // {
        //   headers: {
        //     Authorization: `Bearer ${accessToken}`
        //   }
        // }
      );
      const result = response.data;
      setWorkflowData(result);
      console.log("Workflow Data setWorkflowData:", workflowData);
    } catch (error) {
      console.error("Error fetching workflow data:", error);
    } finally {
      setLoading(false);
    }
  };

  const renderTable = (data) => (
    <div className="table-responsive">
      <table className="table table-hover">
        <thead>
          <tr>
            <th>Order</th>
            <th>Stage</th>
            <th>Approvers</th>
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => (
            <tr key={index}>
              <td>{item.orderNo}</td>
              <td>{item.requestStage}</td>
              <td>{item.stakeHolderNames}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  const getStageStyle = (stage) => {
    // if (stage.isCurrentStage === 1) return { backgroundColor: "#f5c330", height: "17px" }; // Orange for current stage
    // if (stage.isStageApplicable) return { backgroundColor: "#03bb29", height: "17px" }; // Green for applicable stages
    // return { backgroundColor: "#b5b4b4", height: "17px" }; // Gray for non-applicable stages

    {
      /* Commented and Added by Gauri for manage workflow stages on 24 Mar 2025 */
    }
    if (stage.approved === 1) {
      return { backgroundColor: "#03bb29", height: "17px" }; // Green for "Start" stage
    }
    // return { backgroundColor: "#f5c330", height: "17px" }; // Orange for all other stages
    return { backgroundColor: "#b5b4b4", height: "17px" }; // Orange for all other stages
  };

  const handleVisibilityClick = async () => {
    {
      /* Added by Gauri on 02 May 2025 */
    }
    const noiToUse = selectedNOI1 || "";
    // setSelectedNOI1("");

    // Make API call when the visibility icon is clicked
    if (
      noiToUse === "" ||
      noiToUse === undefined ||
      noiToUse === String(currentNOIID)
    ) {
      console.log("Please select Nature of Initiative");
      setShowPreview(false);
    } else {
      setShowPreview(true);
    }

    const url = `/api/ManageWorkFlow/GetManageWorkFlowPreview?IdeaID=${initiativesID}&NOI=${noiToUse}`;

    try {
      const response = await AxiosInstance1.get(url);

      const previewData = response?.data?.data?.listManageWorkflowPreview;
      setCurrentStageData(previewData);
    } catch (error) {
      console.error("Error fetching current stage:", error);
      setShowPreview(false);
    }

    // fetch(
    //   // `${window.runtimeConfig.REACT_APP_BASEURL_ACCESS_CONTROL1}/api/ManageWorkFlow/GetManageWorkFlowPreview?IdeaID=${initiativesID}&NOI=${selectedNOI}`,
    //   `/api/ManageWorkFlow/GetManageWorkFlowPreview?IdeaID=${initiativesID}&NOI=${noiToUse}`,
    //   {
    //     method: "GET",
    //     headers: {
    //       Authorization: `Bearer ${accessToken}`
    //     }
    //   }
    // )
    //   .then((response) => response.json())
    //   .then((data) => {
    //     setCurrentStageData(data.data.listManageWorkflowPreview); // Set the current stage data
    //   })
    //   .catch((error) => console.error("Error fetching current stage:", error));
  };

  // Added by Gauri to save Changed Nature of Initiative on 31 Mar 2025
  const handleNOISave = async () => {
    if (!selectedNOI1) {
      toast.error("Please select the Nature of Initiative to be changed");
      return;
    }

    if (!rationale) {
      toast.error("Rationale cannot be Blank");
      return;
    }

    console.log("currentNOIID NOI:", currentNOIID);
    console.log("Previous NOI:", selectedNOI);
    console.log("Selected NOI:", selectedNOI1);

    const includeCurrentStageValue = includeCurrentStage ? 1 : 0; // Convert boolean to 1/0

    const apiUrl = `/api/ManageWorkFlow/ChangeNatureofInitiative?IdeaID=${encodeURIComponent(
      initiativesID
      // )}&NOI=${encodeURIComponent(previousNOI)}&UserID=${encodeURIComponent(
      // )}&NOI=${encodeURIComponent(currentNOIID)}&UserID=${encodeURIComponent(
    )}&NOI=${encodeURIComponent(selectedNOI1)}&UserID=${encodeURIComponent(
      employeeId
    )}&Rationale=${encodeURIComponent(rationale)}&NewNOI=${encodeURIComponent(
      selectedNOI1
      // )}&IncludeCurrenststage=${includeCurrentStageValue}`;
    )}&IncludeCurrenststage=1`;

    try {
    const response = await AxiosInstance1.post(apiUrl, null, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = response?.data;

    console.log("API Response:", data);

    if (data?.[0]?.result !== "Success") {
      toast.success("Nature of Initiative changed successfully.");
      setPreviousNOI(selectedNOI1);
      setSelectedNOI(selectedNOI1);
      setCurrentNOIID(selectedNOI1);
      setSelectedNOI1("");
      setNOIDrawerOpen(false);

      if (onRefresh) onRefresh();

      const newNOIName = data1.find(
        (item) => item.natureOfDemandID === selectedNOI1
      )?.natureOfDemand;

      if (newNOIName) setCurrentNOIText(newNOIName);
    } else {
      toast.error("Failed to change NOI.");
    }
  } catch (error) {
    console.error("Error saving data:", error);
    toast.error("Failed to change NOI.");
  }
    // fetch(apiUrl, {
    //   method: "POST",
    //   headers: {
    //     Authorization: `Bearer ${accessToken}`,
    //     "Content-Type": "application/json",
    //   },
    // })
    //   .then((response) => response.json())
    //   .then((data) => {
    //     console.log("API Response:", data); // Debugging: Log API response

    //     if (data?.[0]?.result !== "Success") {
    //       toast.success("Nature of Initiative changed successfully.");
    //       setPreviousNOI(selectedNOI1);
    //       setSelectedNOI(selectedNOI1); // Update the main selectedNOI after save
    //       // Added by Gauri to set current NOI ID after save on 09 May 2025
    //       setCurrentNOIID(selectedNOI1);
    //       setSelectedNOI1("");

    //       // setOpen(false); // Close the drawer after saving
    //       setNOIDrawerOpen(false); // Close the drawer after saving

    //       if (onRefresh) {
    //         onRefresh(); // This triggers fetchWorkflowData() in WorkflowDrawer
    //       }
    //       //  Update displayed NOI text
    //       const newNOIName = data1.find(
    //         (item) => item.natureOfDemandID === selectedNOI1
    //       )?.natureOfDemand;
    //       if (newNOIName) setCurrentNOIText(newNOIName);
    //     } else {
    //       toast.error("Failed to change NOI.");
    //     }
    //   })
    //   .catch((error) => {
    //     console.error("Error saving data:", error);
    //     toast.error("Failed to change NOI.");
    //   });
  };

  const stackItemStyle = {
    root: {
      flexGrow: 1,
      minWidth: "200px",
      maxWidth: "300px",
    },
  };

  // Added by Gauri on 20 Nov 2025 - Common calloutProps for all dropdowns
  const commonCalloutProps = {
    // Use bottomAutoEdge which tries to open downward first, then automatically adjusts upward if needed
    directionalHint: DirectionalHint.bottomAutoEdge,
    // Set max height to prevent dropdown from being too large
    calloutMaxHeight: 250,
    // Ensure dropdown stays within viewport bounds
    bounds: typeof window !== 'undefined' ? {
      top: 0,
      left: 0,
      bottom: window.innerHeight,
      right: window.innerWidth
    } : undefined
  };

  return (
    <>
      <Typography
        variant="subtitle1"
        style={{ marginBottom: "20px", fontWeight: "bold" }}
      >
        2. Change Nature of Initiative
      </Typography>

      <div style={{ marginTop: "30px", display: "flex", alignItems: "end" }}>
        {/* Dropdown field changed to FluentUI by Gauri start here on 04 Feb 2025 */}
        <div>
          <Label htmlFor="changeNatureOfInitiative">
            Change Nature of Initiative
          </Label>
          {/* Modified NOI dropdown field by Gauri on 24 Mar 2025 */}
          {/* Modified by Gauri to fix dropdown position issue on 20 Nov 2025 */}
          <Dropdown
            id="changeNatureOfInitiative"
            placeholder="Select Nature of Initiative"
            options={[
              { key: "", text: "Select Nature of Initiative" },
              ...(data1 && data1.length > 0
                ? data1.map((item) => ({
                    // key: item.natureOfDemandID,
                    key: String(item.natureOfDemandID),
                    text: item.natureOfDemand,
                  }))
                : []),
            ]}
            selectedKey={selectedNOI1} // Equivalent to value in MUI
            // selectedKey={String(selectedNOI)} // Equivalent to value in MUI
            // onChange={(e, option) => {
            //   const selectedItem = data1.find((item) => item.natureOfDemandID === option?.key);
            //   setSelectedNOI(option?.key);
            //   setSelectedNOIName(selectedItem?.natureOfDemand || "");
            //   console.log("setSelectedNOIName", option?.key, data1);
            // }}
            // onChange={(e, option) => {
            //   setSelectedNOI(option?.key); // Update main dropdown
            // }}

            //  Added by Gauri on 02 May 2025
            // onChange={(e, option) => {
            //   const selectedKey = option?.key;
            //   if (selectedKey === "") {
            //     // Fallback directly from data2
            //     const fallbackNOIID = data2?.natureofDemandID;
            //     if (fallbackNOIID) {
            //       setSelectedNOI1(String(fallbackNOIID));
            //     } else {
            //       console.warn("Cannot reset: data2.natureofDemandID is undefined");
            //     }
            //   } else {
            //     setSelectedNOI1(selectedKey);
            //   }
            // }}
            onChange={(e, option) => {
              const selectedKey = option?.key;
              // Allow dropdown to be truly cleared
              setSelectedNOI1(selectedKey);
              setSelectedNOI(selectedKey); // Added by Gauri to set selectedNOIID on 09 May 2025
            }}
            styles={{ dropdown: { width: 200 } }} // Inline width style
            calloutProps={commonCalloutProps}
          />
        </div>
        {/* Dropdown field changed to FluentUI by Gauri end here on 04 Feb 2025 */}

        <IconButton
          style={{ marginLeft: "16px" }}
          onClick={handleVisibilityClick}
        >
          <VisibilityIcon fontSize="small" />
        </IconButton>
      </div>
      <div className="mt-3">
        {/* Modified section UI by Gauri start here on 04 Feb 2025 */}
        <Typography variant="body1">
          Preview for New Initiative Stages : {selectedNOIName}
        </Typography>
        {/* Modified section UI by Gauri end here on 04 Feb 2025 */}

        {showPreview && (
          <div
            className="my-2"
            style={{ display: "flex", alignItems: "center", width: "90%" }}
          >
            {currentStageData?.map((stage, index) => (
              <Tooltip
                key={index}
                title={`Stage ${index + 1}: ${stage.requestStage}`}
                aria-label={`Stage ${index + 1}: ${stage.requestStage}`}
              >
                <div
                  id={`stg-bar-${index + 1}`}
                  style={{
                    position: "relative",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "12px",
                    cursor: "pointer",
                    margin: "0",
                    padding: "5px 10px",
                    lineHeight: "1",
                    flex: index === 0 ? "3" : "1", // Larger flex for the first segment
                    ...getStageStyle(stage),
                  }}
                  data-bs-toggle="tooltip"
                >
                  {/* Add semi-circle before and after for each stage */}
                  {index === 0 && (
                    <div style={getSemiCircleStyle(true, false)} />
                  )}
                  {index === currentStageData.length - 1 && (
                    <div style={getSemiCircleStyle(false, true)} />
                  )}
                  {stage.isCurrentStage === 1 && (
                    <a
                      href="javascript:;"
                      style={{
                        zIndex: 2,
                        position: "relative",
                        fontSize: "8px",
                      }} // Font size set here
                      className="progress-text"
                    >
                      {/* Display with one decimal */}
                    </a>
                  )}
                  {/* Optionally add other content inside the stage */}
                  {/* <span style={{ zIndex: 1 }}> Stage {index + 1}</span> Display stage number */}
                  {/* <span style={{ zIndex: 1 }}>{stage.requestStage}</span>  */}
                  <span
                    style={{
                      zIndex: 1,
                      display: "inline-block",
                      width: "max-content",
                    }}
                  >
                    {stage.requestStage.length > 6
                      ? `${stage.requestStage.slice(0, 6)}...`
                      : stage.requestStage}
                  </span>
                </div>
              </Tooltip>
            ))}
          </div>
        )}
      </div>
      {/* Modified section UI by Gauri start here on 04 Feb 2025 */}
      <Typography variant="body1" sx={{ marginBottom: "20px" }}>
        If you need new approval cycle,&nbsp;
        <a
          href="#"
          onClick={async (e) => {
            e.preventDefault(); // Prevent default link behavior
            const isCompletedCurrentStage = data3?.some(
              (stage) =>
                stage.requestStage === "Completed" && stage.isCurrentStage === 1
            );

            if (isCompletedCurrentStage) {
              toast.error(
                "Initiative is on Roadmap stage. Hence can not change Nature of Initiative."
              );
              return;
            }

            // Added by Gauri on 02 May 2025
            const noiToUse = selectedNOI || data2?.natureOfDemandID;
            setSelectedNOI(noiToUse);
            // setCurrentNOIID(data2?.natureOfDemandID);
            // setCurrentNOIID(noiToUse);
            // await handleClick(data2?.natureOfDemandID); // pass it as an argument
            // setSelectedNOI1(data2?.natureOfDemandID);
            // await handleClick(data2?.natureOfDemandID);

            // setSelectedNOI1(noiToUse); // Respect user's selection
            await handleClick(noiToUse); // Pass it to the API call
            setNOIDrawerOpen(true);
          }}
          style={{
            textDecoration: "underline",
            cursor: "pointer",
            fontWeight: "bold",
            color: "blue",
          }}
        >
          Click here
        </a>
      </Typography>
      {/* Modified section UI by Gauri end here on 04 Feb 2025 */}

      <Drawer
        anchor="right"
        open={NOIDrawerOpen}
        onClose={() => {
          setNOIDrawerOpen(false);
          setSelectedNOI1(""); // Reset to previous value
        }}
      >
        <Box sx={{ width: 800, padding: 3 }}>
          {loading ? (
            <CircularProgress />
          ) : workflowData ? (
            <>
              {/* Modified by Gauri to fix Offcanvas header UI on 07 Mar 2025 */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 2,
                  backgroundColor: "#f5f5f5",
                  padding: 1,
                  borderRadius: 1,
                }}
              >
                <h5 className="mb-0">Change Nature of Initiative</h5>
                <Tooltip title="Close" arrow>
                  <IconButton onClick={() => setNOIDrawerOpen(false)}>
                    <CloseIcon />
                  </IconButton>
                </Tooltip>
              </Box>
              {/* End of Modified by Gauri to fix Offcanvas header UI on 07 Mar 2025 */}

              {/* Added by Gauri to save Changed Nature of Initiative on 31 Mar 2025 */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginBottom: "20px",
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleNOISave}
                >
                  Save
                </Button>
              </div>

              <div className="details-div">
                <Typography variant="body2">
                  {/* <strong>Initiative:</strong> Workflow Configure Initiative */}
                  <strong>Initiative:</strong> {data2?.title}
                </Typography>
                <Typography variant="body2">
                  {/* <strong>Current Nature of Initiative:</strong> Tool Implementation */}
                  <strong>Current Nature of Initiative:</strong>{" "}
                  {data2?.natureofDemand}
                </Typography>
              </div>

              {/* Dropdown field changed to FluentUI by Gauri start here on 04 Feb 2025 */}
              <div style={{ marginTop: "10px" }}>
                <Label htmlFor="changeNatureOfInitiative">
                  Change Nature of Initiative{" "}
                  <span style={{ color: "red" }}>*</span>
                </Label>
                {/* <Dropdown
                  id="changeNatureOfInitiative"
                  placeholder="Select Nature of Initiative"
                  options={[
                    { key: "", text: "Select Nature of Initiative" },
                    ...(data1 && data1.length > 0
                      ? data1.map((item) => ({
                        key: item.natureOfDemandID,
                        text: item.natureOfDemand,
                      }))
                      : []),
                  ]}
                  // Commented and Added by Gauri to by default select NOI value on 10 Mar 2025
                  // selectedKey={selectedNOI1} // Equivalent to value in MUI
                  // selectedKey={selectedNOI} // Equivalent to value in MUI
                  // onChange={(e, option) => setSelectedNOI1(option?.key)} // Update selected value
                  // onChange={(e, option) => setSelectedNOI(option?.key)}
                  selectedKey={selectedNOI1} // Drawer dropdown controls selectedNOI1
                  // onChange={(e, option) => {
                  //   setSelectedNOI1(option?.key); // Only update drawer dropdown
                  // }}
                  onChange={(e, option) => setNewSelectedNOI(option?.key)} 
                  styles={{ dropdown: { width: 200 } }} // Set width
                /> */}
                {/* Modified by Gauri to fix dropdown position issue on 20 Nov 2025 */}
                <Dropdown
                  id="changeNatureOfInitiative"
                  placeholder="Select Nature of Initiative"
                  options={[
                    { key: "", text: "Select Nature of Initiative" },
                    ...(data1 && data1.length > 0
                      ? data1.map((item) => ({
                          // key: item.natureOfDemandID,
                          key: String(item.natureOfDemandID),
                          text: item.natureOfDemand,
                        }))
                      : []),
                  ]}
                  selectedKey={selectedNOI1} // Controls dropdown
                  // selectedKey={selectedNOI} // Controls dropdown
                  // onChange={(e, option) => setSelectedNOI(option?.key)} // Updates state
                  //   onChange={(e, option) => setSelectedNOI1(option?.key)} // Updates state

                  // Added by Gauri to show details on change of dropdown on 08 May 2025
                  onChange={async (e, option) => {
                    const selectedKey = option?.key;

                    setSelectedNOI1(selectedKey); // Set the dropdown value

                    if (selectedKey) {
                      await handleClick(selectedKey); // Will use selectedNOI1, which is now updated
                    }
                  }}
                  styles={{ dropdown: { width: 200 } }}
                  calloutProps={commonCalloutProps}
                />
              </div>
              {/* Dropdown field changed to FluentUI by Gauri end here on 04 Feb 2025 */}

              {/* <div styles={stackItemStyle}> */}
              <div style={{ width: "300px", marginTop: "10px" }}>
                <TextField
                  label={
                    <>
                      Rationale <span style={{ color: "red" }}>*</span>
                    </>
                  }
                  multiline
                  value={rationale}
                  onChange={(e) => setRationale(e.target.value)}
                  sx={{
                    "& .MuiInputBase-root": {
                      backgroundColor: "#fff",
                    },
                  }}
                />
              </div>

              {/* Commented by Gauri on 09 May 2025 */}
              {/* <div style={{ display: "flex", alignItems: "center", marginTop: "10px" }}>
                <Label htmlFor="changeNatureOfInitiative">
                  Include Current Stage
                </Label>
                <Checkbox
                  checked={includeCurrentStage}
                  onChange={(e, checked) => setIncludeCurrentStage(checked)}
                />
              </div> */}

              {/* Corrected Changed NOI details by Gauri for manage workflow issue on 24 Mar 2025 */}
              {/* {selectedNOI1 !== data2?.natureofDemandID && ( */}
              {/* {(!selectedNOI1 === "" || selectedNOI1 === undefined) && ( */}
              {selectedNOI1 && (
                <Accordion defaultExpanded>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography>
                      Changed Nature of Initiative Details
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    {renderTable(
                      workflowData?.data?.listManageWorkChangeNOINOI
                    )}
                  </AccordionDetails>
                </Accordion>
              )}

              <Accordion defaultExpanded>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography>Current Nature of Initiative Details</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  {renderTable(workflowData?.data?.listManageWorkCurrentNOI)}
                </AccordionDetails>
              </Accordion>
            </>
          ) : (
            <Typography>No data available</Typography>
          )}
        </Box>
      </Drawer>
    </>
  );
};

export default WorkflowChangeNOI;
